<template>
  <div class="confirm-page">
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="content">
        <p class="success">
          <img src="../../assets/images/success.png" alt="">
        </p>
        <p class="mainTitle">We have successfully received your rental request.</p>
        <p>Your rental confirmation ID is</p>
        <p class="fw mb-20">{{ dealId }}</p>
        <p>Email confirmations will be sent to the business contact email</p>
<!--        <p></p>-->
        <p class="fw mb-20">{{ businessEmail }}</p>
        <div v-if="sendRentalRequestConfirmationMailToShippingContact && shippingEmail">
          <p>And</p>
          <p>shipping contact email</p>
          <p class="fw mb-20">{{ shippingEmail }}</p>
        </div>
        <div v-if="sendRentalRequestConfirmationMailToOperator && operatorContactEmail">
          <p>And</p>
          <p>TVU Operator email</p>
          <p class="fw mb-20">{{ operatorContactEmail }}</p>
        </div>
        <br>
        <p class="note"><i>Note: A confirmation email has also been sent to you.</i></p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain class="viewRequest"
          @click="viewOldRequest">Review my requests</el-button>
      <el-button type="primary" @click="handleClose(true)">Print Receipt</el-button>
    </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'ConfirmPage',
  props: {
    dealId: String,
    businessEmail: String,
    shippingEmail: String,
    operatorContactEmail: String,
    showConfirm: Boolean,
    sendRentalRequestConfirmationMailToShippingContact: Boolean,
    sendRentalRequestConfirmationMailToOperator: Boolean
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  created () {
    this.dialogVisible = this.showConfirm
  },
  methods: {
    handleClose (print) {
      if (print === true) {
        this.$emit('closeConfirm', true)
      } else {
        this.$emit('closeConfirm', false)
      }
    },
    viewOldRequest () {
      this.$emit('showRequest')
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-dialog {
  background: #FFFFFF !important;
}

/deep/ .el-dialog__wrapper .el-dialog .el-dialog__header .el-dialog__headerbtn .el-icon-close:before {
  color: #555;
  font-weight: 600;
  font-size: 20px;
}

.content {
  color: #666666;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;

  p {
    line-height: 24px;
  }

  .fw {
    font-weight: 700;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .success {
    img {
      width: 48px;
      height: 48px;
    }
  }
  .mainTitle{
    font-weight: 700;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    margin-bottom: 20px;
  }

  .note {
    font-weight: 500;
    font-style: Medium Italic;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 14px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
  }
}
.viewRequest {
  background: #fff;
  color: #33ab4f;
  margin-right: 20px;
  width: 160px;
  height: 40px;
}
</style>
